import preact from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss';

import CategoryButton from './CategoryButton/CategoryButton';
import CategoryQuestions from './CategoryQuestions/CategoryQuestions';
import CategoryScroll from './CategoryScroll/CategoryScroll';
import NavButton from './NavButton/NavButton'
import SearchResults from './SearchResults/SearchResults'

import CustomizationModel from '/chat/src/redux/model/customization/model';
import SystemModel from '/chat/src/redux/model/system/model';
import FeaturesModel from '/chat/src/redux/model/features/model';

import PersistentRouting from '/chat/src/lib/LocalStorage/PersistentRouting'

/*
    NOTE Category are referenced with two indices:
        1. Layout index: CategoryButtons are referenced with indices w/ values 0-8 (activeCategory).
        Therefore, the component seldom works directly with the category ID. This index is important to calculate which row
        and column each item is located in.

        2. ID: When requesting data for an item (category ID or question ID), it uses the the cateogory ID.

    NOTE There are always 9 CategoryButtons. This makes it easier to manage layout and keeping sanity.
*/
class HelpDeskBody extends preact.Component {
    constructor(props) {
        super(props)
        this.row = 0;
        this.container = null;
        this.state = {
            animating: false,
        }
    }

    onClickCategory(id) {
        return () => {
            if (this.state.animating) return

            const currentRoute = this.props.route;
            const focused = currentRoute === 'HelpDeskFocused'
            if (id === this.props.activeCategory) {
                if (!this.state.animating)
                    setTimeout( () => {
                        this.setState({ animating: false })
                        this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDesk'))
                    }, 400 )
                this.setState({ animating: true })
            }
            else if (focused && (id !== this.props.activeCategory)) {
                this.props.dispatch(SystemModel.setHelpDeskRoute(currentRoute, id))
            }
            else {
                if (!this.state.animating)
                setTimeout( () => {
                    this.setState({ animating: false })
                    this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDeskFocused', id))
                }, 400 )
                this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDesk', id))
                this.setState({ animating: true })
            }
        }
    }

    navigateCategories(nav) {
        const { activeCategory, categories } = this.props;
        const lenCategories = categories.length;
        const maximumRow = Math.floor((categories.length-1) / 3);
        const currentRow = Math.floor(activeCategory / 3);

        let newRow;
        switch(nav) {
            case 'back':
                newRow = (currentRow - 1) < 0 ? maximumRow : (currentRow - 1)
                break;
            case 'next':
            default:
                newRow = (currentRow + 1) > maximumRow ? 0 : (currentRow + 1)
                break;
        }
        //First column in the newRow.
        const nextIdx = newRow * 3
        this.props.dispatch(SystemModel.setHelpDeskRoute('HelpDeskFocused', nextIdx))
    }



    _renderRow(row) {
        const focused = this.props.route === 'HelpDeskFocused'
        const heightNav = this.row ? {height: `${this.row.clientHeight/2}px`} : {height: '100px'};
        const rowClass = focused ?  style.RowFocused : style.Row;
        const categoriesOccupySingleRow = this.props.categories.length <= 3;

        const categories = this.props.categories;
        const btns = [];
        const startIdx = row*3;
        for (let i = startIdx; i < startIdx + 3; i++) {
            if (i < this.props.categories.length) {
                btns.push(
                    <CategoryButton
                    onClick={this.onClickCategory(i)}
                    catName={categories[i]['category']}
                    color={this.props.color}
                    imgSrc={'https://storage.googleapis.com/jibber-image/images/' + categories[i]['imgSrc']}/>
                )
            } else {
                btns.push(<CategoryButton/>)
            }
        }

        return (
            <div style={this.__animationStyle(row)} className={rowClass} ref={ node => this.row = node ? node : this.row }>
                {/*this.row is used to determine the offset of the question container, since the categorybuttons are display:absolute*/}
                <NavButton
                    onClick={() => this.navigateCategories('back')}
                    display={(focused && !this.state.animating) && !categoriesOccupySingleRow}
                    direction='left' color={this.props.color}>
                </NavButton>
                {btns}
                <NavButton
                    onClick={() => this.navigateCategories('next')}
                    display={(focused && !this.state.animating) && !categoriesOccupySingleRow}
                    direction='right' color={this.props.color}>
                </NavButton>
                <CategoryScroll
                    activeCategory={this.props.activeCategory}
                    color={this.props.color}
                    display={focused && !this.state.animating}/>
            </div>
        )
    }

    _renderCategories() {
        const focused = this.props.route === 'HelpDeskFocused';
        //4px for extra spacing
        const categoriesHeight = this.row ? {height: `${this.row.clientHeight+10}px`} : {height: '100px'};
        return (
            <div className={style.Container} style={categoriesHeight}>
                <div className={style.CategoriesWrapper} style={categoriesHeight}>
                    {this._renderRow(0)}
                    {this._renderRow(1)}
                    {this._renderRow(2)}
                </div>
            </div>
        )
    }

    _renderQuestions() {
        const focused = this.props.route === 'HelpDeskFocused'
        const questionsHeight = this.row ? this.props.height- this.row.clientHeight-20 : 120;
        return (
            <div className={style.QuestionsContainer} style={{height: `${questionsHeight}px`}}>
                { (focused && !this.state.animating) &&
                    <CategoryQuestions
                        questions={this.props.questions}
                        activeCategory={this.props.activeCategory}/> }
            </div>
        )
    }


    render() {
        const focused = this.props.route === 'HelpDeskFocused'
        const overflowY = focused ? 'hidden' : 'auto';
        return (
            <div className={style.HelpDeskBodyContainer} style={{overflowY: overflowY, height: `${this.props.height}px`}}>
                {this._renderCategories()}
                {this._renderQuestions()}
            </div>
        )
    }

    __animationStyle(rowIdx) {
        let translation, opacity, visibility;
        const animating = this.state.animating;
        const focusedMode = this.props.route === 'HelpDeskFocused';
        const activeRow = Math.floor(this.props.activeCategory / 3);
        if (animating) {
            //Animating towards focusedMode == false, else towards focused == true
            if (focusedMode) {
                translation = 0
                opacity = 1
                visibility = 'visible'
            } else {
                translation = rowIdx * -100
                opacity = (rowIdx === activeRow) ? 1 : 0;
                visibility = 'visible'
            }
        } else {
            if (focusedMode) {
                translation = rowIdx * -100
                opacity = (rowIdx === activeRow) ? 1 : 0
                visibility = (rowIdx === activeRow) ? 'visible' : 'hidden'
            } else {
                translation = 0
                opacity = 1
                visibility = 'visible'
            }
        }
        return {
            transform: `translateY(${translation}%)`,
            opacity: opacity,
            visibility: visibility
        }
    }
}

function mapStateToProps(state) {
    let fullRoute = SystemModel.getHelpDeskRoute(state).split(';');
    const route = fullRoute[0];
    const activeCategory = parseInt(fullRoute[1]);
    const color = CustomizationModel.getColor(state);
    const categories = FeaturesModel.getActiveCategories(state);
    const questions = FeaturesModel.getActiveQuestions(state);
    return {
        height: SystemModel.getBodyHeight(state),
        color: color,
        activeCategory: activeCategory,
        route: route,
        categories: categories.toJS(),
        questions: questions
    };
}

export default connect(mapStateToProps)(HelpDeskBody);



// WEBPACK FOOTER //
// ./routes/HelpDesk/Body.js